<template lang="pug">
  div(class="create-contact-errors")
    v-img(
      :src="require('~/assets/images/check-green.png')"
      max-width="72"
    )
    h2(class="title-32px bold mb-2 create-contact-status__title") {{ title }}
    div(class="create-contact-status__content")
      div(class="create-contact-errors__description") {{ description }}
      div(
        v-if="errors && errors.length > 0"
        class="create-contact-errors__info"
      )
        table(class="create-contact-errors__table")
          thead
            tr
              th {{ $t('Row') }}
              th {{ $t('Description error') }}
          tbody
            tr(
              v-for="error in errors"
              :key="error.row"
            )
              td {{ error.row }}
              td {{ error.message }}
      v-btn(
        class="main-button"
        @click="closeModal"
      ) {{ buttonText }}
</template>

<script>
import Contact from '~/modules/contacts/models/Contact'

export default {
  name: 'MCreateContactErrors',
  props: {
    title: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: null
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    success: {
      type: Number,
      default: 0
    },
    failed: {
      type: Number,
      default: 0
    }
  },
  computed: {
    buttonText() {
      return this.errors.length ? this.$t('Ok') : this.$t('Go to contacts')
    },
    description() {
      return this.errors.length
        ? this.$t(
            'Successfully imported {successCount} contacts. {errorCount} contacts contained errors and were not added.',
            {
              successCount: this.success,
              errorCount: this.failed
            }
          )
        : this.$t(
            'All contacts have been imported into the system. Total number of contacts added: {count}',
            { count: this.success }
          )
    }
  },
  created() {
    Contact.api().filter(this.params).all()
  }
}
</script>

<style lang="scss">
.create-contact-errors {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__title {
    margin-top: 16px;
  }

  &__description {
    font-size: 14px;
  }

  &__content {
    margin-top: 32px;
    width: 100%;

    & > button {
      min-width: 100% !important;
    }
  }

  &__info {
    margin-top: 16px;
    background: #f8f8f8;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  &__table {
    margin-top: 16px;
    width: 100%;

    th,
    td {
      padding: 6px;
      font-size: 14px;
      white-space: pre-line;
    }
    td:first-of-type {
      text-align: center;
    }

    th {
      border-bottom: 1px solid #e0e0e0;
    }

    th {
      background-color: #f8f8f8;
      font-weight: 500;
      font-size: 14px;
      color: #676767;
    }
  }

  &__description {
    margin-bottom: 20px;
  }
}
</style>
